<!--
{
  "type": "highlights",
  "data": {
    "title": "",
    "description": "",
    "layout": "striped_left" | "striped_right" | "image_left" | "image_right"
    "style": "image-leadline-title-description-button" | "quote",
    "columns": 2,
    "items": [
      {
        "title": "",
        "leadline": "",
        "description": "",
        "button": {
          "url": "",
          "title": ""
        },
        "media": {
          "filestorename": "website",
          "filepath": "/path/to/file",
          "data" {
            "title": "",
            "alt": "",
            "iconratio": "16-10" | "16-9" | "3-2" | "4-3" | "3-4" | "1-1",
            "preset": "presetname"
          }
        }
      }
      ...
    ]
  }
}
-->
<template>
  <b-container>
    <b-row v-if="title">
      <b-col><h3>{{ title }}</h3></b-col>
    </b-row>
    <b-row v-if="description">
      <b-col
        class="description"
        v-html="description"
      />
    </b-row>
    <b-row>
      <b-col>
        <sp-feature-highlights
          :highlights="highlights"
          :highlights-layout="highlightsLayout"
          :highlights-style="highlightsStyle"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'slice-type-highlights',
  props: {
    slice: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    data() {
      return this.slice.data
    },
    title() {
      return this.data.title
    },
    description() {
      return this.data.description
    },
    highlightsLayout() {
      return this.data.layout
    },
    highlightsStyle() {
      return this.data.style
    },
    highlights() {
      return this.data.items
    }
  }
}
</script>

<style scoped lang="scss">
  h3, .description {
    text-align: center;
  }
</style>
